import { api } from './http';
import type { Course, CourseInput, Lesson, LessonInput } from './types';

/* The console's CRUD factory answers { items } and { item } for everything it
   registers, which is why these all look the same. */
export const courses = {
  list: (signal?: AbortSignal) => api.get<{ items: Course[] }>('/courses', signal),
  get: (id: number) => api.get<{ item: Course }>(`/courses/${id}`),
  create: (f: CourseInput) => api.post<{ item: Course }>('/courses', f),
  update: (id: number, f: CourseInput) => api.put<{ item: Course }>(`/courses/${id}`, f),
  remove: (id: number) => api.del<{ ok: true }>(`/courses/${id}`),
};

export const lessons = {
  list: (signal?: AbortSignal) => api.get<{ items: Lesson[] }>('/lessons', signal),
  get: (id: number) => api.get<{ item: Lesson }>(`/lessons/${id}`),
  create: (f: LessonInput) => api.post<{ item: Lesson }>('/lessons', f),
  update: (id: number, f: LessonInput) => api.put<{ item: Lesson }>(`/lessons/${id}`, f),
  remove: (id: number) => api.del<{ ok: true }>(`/lessons/${id}`),
};

